// import React, { useState } from "react";
// import {
//   useFetchSavedItemsQuery,
//   useRemoveSavedItemMutation,
// } from "../slices/savedItemsSlice";
// import { useDispatch } from "react-redux";
// import { addToCart } from "../slices/cartSlice";
// import Success from "../components/message/Success";
// import Error from "../components/message/Error";
// import Pagination from "../components/utilComponents/Pagination";

// const SavedItems = () => {
//   const [page, setPage] = useState(1);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   // Fetch saved items with pagination
//   const { data, isLoading, error, refetch } = useFetchSavedItemsQuery({
//     page,
//     limit: 10,
//   });

//   // Mutations
//   const [removeSavedItem] = useRemoveSavedItemMutation();
//   const dispatch = useDispatch();

//   // Handle removing an item from saved items
//   const handleRemove = async (productId) => {
//     try {
//       await removeSavedItem({ productId }).unwrap();
//       setSuccessMessage("Item removed from saved items.");
//       refetch(); // Refetch the saved items to update the list
//     } catch (error) {
//       setErrorMessage("Failed to remove item.");
//     }
//   };

//   // Handle adding an item to the cart
//   const handleAddToCart = async (product) => {
//     if (!product || !product.vendor) {
//       setErrorMessage("Product or vendor information is missing!");
//       return;
//     }

//     const cartItem = {
//       productId: product._id,
//       qty: 1,
//       price: product.discountedPrice || product.originalPrice,
//       vendorId: product.vendor._id,
//       storeName: product.vendor.storeName,
//     };

//     try {
//       await dispatch(addToCart(cartItem)).unwrap();
//       setSuccessMessage(`${product.title} added to cart successfully!`);
//     } catch (error) {
//       const errorMessage =
//         error?.response?.data?.message ||
//         error?.message ||
//         "An unexpected error occurred.";
//       setErrorMessage(errorMessage);
//     }
//   };

//   if (isLoading) {
//     return <p>Loading saved items...</p>;
//   }

//   if (error) {
//     return <p>Error fetching saved items: {error.message}</p>;
//   }

//   const { savedItems, totalPages } = data;

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-xl font-semibold mb-4">Saved Items</h1>

//       {/* Success and Error Message Components */}
//       {successMessage && (
//         <Success
//           message={successMessage}
//           onClose={() => setSuccessMessage("")}
//         />
//       )}
//       {errorMessage && (
//         <Error message={errorMessage} onClose={() => setErrorMessage("")} />
//       )}

//       {savedItems.length > 0 ? (
//         <div>
//           {savedItems.map((item) => {
//             const product = item.productId;

//             if (!product) {
//               return (
//                 <div
//                   key={item._id}
//                   className="flex items-center justify-between border p-4 rounded-md mb-4"
//                 >
//                   <p className="text-red-600">Product not available.</p>
//                   <button
//                     className="text-red-600 text-sm"
//                     onClick={() => handleRemove(item._id)}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               );
//             }

//             return (
//               <div
//                 key={product._id}
//                 className="flex items-center justify-between border p-4 rounded-md mb-4"
//               >
//                 <div className="flex items-center space-x-4">
//                   <img
//                     src={product.images?.[0] || "/placeholder.png"}
//                     alt={product.title || "Product"}
//                     className="w-16 h-16 object-cover rounded-md"
//                   />
//                   <div>
//                     <h4 className="font-semibold">{product.title}</h4>
//                     <p className="text-sm text-gray-600">
//                       by {product.vendor?.storeName || "Unknown Vendor"}
//                     </p>
//                     <p className="text-lg font-medium text-green-600">
//                       {product.discountedPrice !== undefined
//                         ? `₦${product.discountedPrice.toLocaleString()}`
//                         : "Price unavailable"}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-end">
//                   {product.quantity > 0 ? (
//                     <button
//                       className="bg-green-600 text-white py-2 px-4 rounded-md mb-2"
//                       onClick={() => handleAddToCart(product)}
//                     >
//                       Add to Cart
//                     </button>
//                   ) : (
//                     <span className="bg-gray-400 text-white py-2 px-4 rounded-md mb-2">
//                       Out of Stock
//                     </span>
//                   )}
//                   <button
//                     className="text-red-600 text-sm"
//                     onClick={() => handleRemove(product._id)}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               </div>
//             );
//           })}

//           {/* Pagination Component */}
//           <Pagination
//             currentPage={page}
//             totalPages={totalPages}
//             onPageChange={(newPage) => setPage(newPage)}
//           />
//         </div>
//       ) : (
//         <p className="text-gray-500">No saved items found.</p>
//       )}
//     </div>
//   );
// };

// export default SavedItems;

import React, { useState } from "react";
import {
  useFetchSavedItemsQuery,
  useRemoveSavedItemMutation,
} from "../slices/savedItemsSlice";
import { useDispatch } from "react-redux";
import { addToCart } from "../slices/cartSlice";
import Success from "../components/message/Success";
import Error from "../components/message/Error";
import Pagination from "../components/utilComponents/Pagination";

const SavedItems = () => {
  const [page, setPage] = useState(1);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Fetch saved items with pagination
  const { data, isLoading, error, refetch } = useFetchSavedItemsQuery({
    page,
    limit: 10, // Items per page
  });

  // Mutations
  const [removeSavedItem] = useRemoveSavedItemMutation();
  const dispatch = useDispatch();

  // Handle removing an item from saved items
  const handleRemove = async (productId) => {
    try {
      await removeSavedItem({ productId }).unwrap();
      setSuccessMessage("Item removed from saved items.");
      refetch(); // Refetch the saved items to update the list
    } catch (error) {
      setErrorMessage("Failed to remove item.");
    }
  };

  // Handle adding an item to the cart
  const handleAddToCart = async (product) => {
    if (!product || !product.vendor) {
      setErrorMessage("Product or vendor information is missing!");
      return;
    }

    const cartItem = {
      productId: product._id,
      qty: 1,
      price: product.discountedPrice || product.originalPrice,
      vendorId: product.vendor._id,
      storeName: product.vendor.storeName,
    };

    try {
      await dispatch(addToCart(cartItem)).unwrap();
      setSuccessMessage(`${product.title} added to cart successfully!`);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred.";
      setErrorMessage(errorMessage);
    }
  };

  if (isLoading) {
    return <p>Loading saved items...</p>;
  }

  if (error) {
    return <p>Error fetching saved items: {error.message}</p>;
  }

  const { savedItems, totalPages } = data;

  return (
    <div className="mx-auto">
      {/* <div className="container mx-auto p-4"> */}
      <h1 className="text-xl font-semibold mb-4">Saved Items</h1>

      {/* Success and Error Message Components */}
      {successMessage && (
        <Success
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <Error message={errorMessage} onClose={() => setErrorMessage("")} />
      )}

      {savedItems.length > 0 ? (
        <div>
          {savedItems.map((item) => {
            const product = item.productId;

            if (!product) {
              return (
                <div
                  key={item._id}
                  className="flex items-center justify-between border p-4 rounded-md mb-4"
                >
                  <p className="text-red-600">Product not available.</p>
                  <button
                    className="text-red-600 text-sm"
                    onClick={() => handleRemove(item._id)}
                  >
                    Remove
                  </button>
                </div>
              );
            }

            return (
              <div
                key={product._id}
                className="flex items-center justify-between border p-4 rounded-md mb-4"
              >
                <div className="flex items-center space-x-4">
                  <img
                    src={product.images?.[0] || "/placeholder.png"}
                    alt={product.title || "Product"}
                    className="w-16 h-16 object-cover rounded-md"
                  />
                  <div>
                    <h4 className="font-semibold">{product.title}</h4>
                    <p className="text-sm text-gray-600">
                      by {product.vendor?.storeName || "Unknown Vendor"}
                    </p>
                    <p className="text-lg font-medium text-green-600">
                      {product.discountedPrice !== undefined
                        ? `₦${product.discountedPrice.toLocaleString()}`
                        : "Price unavailable"}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  {product.quantity > 0 ? (
                    <button
                      className="bg-green-600 text-white py-2 px-4 rounded-md mb-2"
                      onClick={() => handleAddToCart(product)}
                    >
                      Add to Cart
                    </button>
                  ) : (
                    <span className="bg-gray-400 text-white py-2 px-4 rounded-md mb-2">
                      Out of Stock
                    </span>
                  )}
                  <button
                    className="text-red-600 text-sm"
                    onClick={() => handleRemove(product._id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            );
          })}

          {/* Pagination Component */}
          {savedItems.length > 10 && ( // Only show pagination if items are greater than 10
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={(newPage) => setPage(newPage)}
            />
          )}
        </div>
      ) : (
        <p className="text-gray-500">No saved items found.</p>
      )}
    </div>
  );
};

export default SavedItems;
